<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11.048" viewBox="0 0 14 11.048" class="scaling-svg">
      <path
        d="M12.1,10.644v-.27A1.437,1.437,0,0,1,11.037,9a.419.419,0,0,1,.837,0,.649.649,0,0,0,1.116.424.562.562,0,0,0-.219-.911l-.825-.33a1.4,1.4,0,0,1-.857-.99A1.377,1.377,0,0,1,12.1,5.582V5.312a.419.419,0,0,1,.837,0v.269A1.44,1.44,0,0,1,14,6.953a.419.419,0,0,1-.837,0,.648.648,0,0,0-1.1-.439.561.561,0,0,0,.2.927l.825.33a1.356,1.356,0,0,1,.47,2.249,1.478,1.478,0,0,1-.624.354v.271a.419.419,0,0,1-.837,0Zm-10.039.4A2.028,2.028,0,0,1,0,9.06V1.989A2.028,2.028,0,0,1,2.061,0h9.877A2.028,2.028,0,0,1,14,1.989V3.68a.628.628,0,0,1-1.254,0V2.205L7.424,6.893a.645.645,0,0,1-.846,0l-.723-.638L2.142,9.838H9.231a.606.606,0,1,1,0,1.21ZM1.254,8.982,4.928,5.438,1.254,2.2ZM2,1.213,7,5.626,12.01,1.214c-.035,0-3.75,0-5.345,0C4.438,1.21,2.028,1.21,2,1.213Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class RequestsForPaymentIcon extends Vue {}
</script>

<style>
</style>
